import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { ChangePasswordComponent } from './authentication/change-password/change-password.component';
import { AuthGuard } from './core/guard/auth.guard';
import { permissionGuard } from './core/guard/permission.guard';
import { PERMISSIONS } from './core/constants/permissions';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./landing/dashboard/dashboard-landing.component').then(
        (m) => m.DashboardLandingComponent,
      ),
  },
  { path: 'login', component: LoginComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  {
    path: 'expense',
    loadChildren: () =>
      import('./expense-management/expense-management-routing.module').then((e) => e.routes),
  },
  {
    path: 'recruitment',
    loadChildren: () =>
      import('./applicant-tracking/applicant-tracking-routing.module').then((r) => r.routes),
  },
  {
    path: 'careers',
    loadChildren: () =>
      import('./public-careers/public-careers-routing.module').then((p) => p.routes),
  },
  { path: 'pay', loadChildren: () => import('./pay/pay-routing.module').then((m) => m.routes) },
  {
    path: 'devices',
    loadChildren: () => import('./devices/devices-routing.module').then((d) => d.routes),
  },
  {
    path: 'employee',
    loadChildren: () => import('./employee/employee-routing.module').then((e) => e.routes),
  },
  {
    path: 'time',
    loadChildren: () => import('./leave/leave-routing.module').then((l) => l.routes),
  },
  {
    path: 'leave',
    loadChildren: () => import('./leave/leave-routing.module').then((l) => l.routes),
  },
  {
    path: 'documents',
    loadChildren: () => import('./documents/documents-routing.module').then((d) => d.routes),
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports-routing.module').then((r) => r.routes),
  },
  {
    path: 'config',
    loadChildren: () => import('./config/config-routing.module').then((c) => c.routes),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./config/config-routing.module').then((c) => c.settingsRoutes),
  },
  // {path: 'worklist', loadChildren: () => import('./worklist/worklist-routing.module').then(w=>w.routes)},
  {
    path: 'worklist',
    canActivate: [AuthGuard, permissionGuard],
    data: { permission: PERMISSIONS.APPROVAL.REQUEST.VIEW },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./worklist/worklist.component').then((m) => m.WorklistComponent),
      },
      {
        path: ':section',
        loadComponent: () =>
          import('./worklist/worklist.component').then((m) => m.WorklistComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
